import { takeEvery, put, call } from "redux-saga/effects"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Calender Redux States
import {
  ADD_NEW_EVENT,
  DELETE_EVENT,
  GET_CATEGORIES,
  GET_EVENTS,
  UPDATE_EVENT,
  GET_UPCOMMINGEVENT
} from "./actionTypes"

import {
  getEventsSuccess,
  getEventsFail,
  addEventFail,
  addEventSuccess,
  updateEventSuccess,
  updateEventFail,
  deleteEventSuccess,
  deleteEventFail,
  getCategoriesSuccess,
  getCategoriesFail,
  getUpCommingEventSuccess,
  getUpCommingEventFail
} from "./action"

//Include Both Helper File with needed methods
import {
  getEvents,
  addNewEvent,
  updateEvent,
  approveEvent,
  deleteEvent,
  getCategories,
  getUpCommingEvent
} from "../../helpers/backend_helper"

function* fetchEvents() {
  try {
    const response = yield call(getEvents)
    yield put(getEventsSuccess(response))
  } catch (error) {
    yield put(getEventsFail(error))
  }
}

function* onAddNewEvent({ payload: event }) {
  try {
    const response = yield call(addNewEvent, event)
    yield put(addEventSuccess(response))
    toast.success("Request berhasil", { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEventFail(error))
    toast.error("Request gagal", { position: "bottom-left", autoClose: 3000 });
  }
}

function* onUpdateEvent({ payload: event }) {
  try {
    if (event.setApprove) {
      const response = yield call(approveEvent, event)
      yield put(updateEventSuccess(response))
      toast.success("Request berhasil", { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateEvent, event)
      yield put(updateEventSuccess(response))
      toast.success("Request berhasil", { position: "bottom-left", autoClose: 3000 });
    }

  } catch (error) {
    yield put(updateEventFail(error))
    toast.error("Request gagal", { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEvent({ payload: event }) {
  try {
    const response = yield call(deleteEvent, event)
    yield put(deleteEventSuccess(response))
    toast.success("Request berhasil", { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEventFail(error))
    toast.error("Request gagal", { position: "bottom-left", autoClose: 3000 });
  }
}

function* onGetCategories() {
  try {
    const response = yield call(getCategories)
    yield put(getCategoriesSuccess(response))
  } catch (error) {
    yield put(getCategoriesFail(error))
  }
}

function* onGetUpcommingEvents() {
  try {
    const response = yield call(getUpCommingEvent)
    yield put(getUpCommingEventSuccess(response))
  } catch (error) {
    yield put(getUpCommingEventFail(error))
  }
}

function* calendarSaga() {
  yield takeEvery(GET_EVENTS, fetchEvents)
  yield takeEvery(ADD_NEW_EVENT, onAddNewEvent)
  yield takeEvery(UPDATE_EVENT, onUpdateEvent)
  yield takeEvery(DELETE_EVENT, onDeleteEvent)
  yield takeEvery(GET_CATEGORIES, onGetCategories)
  yield takeEvery(GET_UPCOMMINGEVENT, onGetUpcommingEvents)

}

export default calendarSaga
